"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorType = void 0;
/*
  If you change these you will have to apply the same changes for
  ErrorTypes in: "/app/src/models/ErrorTypes" because app could
  not read these for some reason :(
*/
var ErrorType;
(function (ErrorType) {
    ErrorType["UserDoesNotExist"] = "user_does_not_exist";
    ErrorType["EmailAlreadyExistRegister"] = "email_already_exist_register";
    ErrorType["EmailAlreadyExistLogin"] = "email_already_exist_login";
    ErrorType["EmailIsRequired"] = "email_is_required";
})(ErrorType = exports.ErrorType || (exports.ErrorType = {}));
//# sourceMappingURL=ErrorType.js.map